/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendtoday2Inputs */

const en_actionendtoday2 = /** @type {(inputs: Actionendtoday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today until`)
};

const de_actionendtoday2 = /** @type {(inputs: Actionendtoday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute bis`)
};

/**
* | output |
* | --- |
* | "Today until" |
*
* @param {Actionendtoday2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendtoday2 = /** @type {((inputs?: Actionendtoday2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendtoday2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendtoday2(inputs)
	return de_actionendtoday2(inputs)
});
export { actionendtoday2 as "actionEndToday" }